import { Map as iMap } from 'immutable';

export const TOGGLE_NAV = 'TOGGLE_NAV';

const initialState = iMap({
  isNavOpen: false
});

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case TOGGLE_NAV:
      return state.merge({ isNavOpen: payload });
    default:
      return state;
  }
}

export const toggleNav = payload => ({ type: TOGGLE_NAV, payload });



// WEBPACK FOOTER //
// ./src/state/app-dux.js